import { createSelector } from 'reselect';
import moment from 'moment-timezone';
import path from 'ramda/es/path';

import { APP_ACCESS } from 'app/common/constants/services';
import { getIsAppConnected } from 'app/selectors/applications';
import getNumEnding from 'app/common/lib/getNumEnding';
import isToday from 'app/selectors/isToday';


const accessEnabled = createSelector(
  [
    (state, { id }) => getIsAppConnected(state, { id, app: APP_ACCESS }),
    isToday,
    (state, { id }) => path(['students', 'data', id, 'passagesExternalService']),
  ],
  (isConnected, isTodayNow, isExternal) => (isExternal
    || (isConnected ? true : !isTodayNow))
);

/**
* Создает селектор для получения данных для карты проходов в «Моих детях»
*/
const makePassageInstance = () => createSelector(
  [
    (state, { id }) => state.passages.short[id] && state.passages.short[id].first,
    (state, { id }) => state.passages.short[id] && state.passages.short[id].penult,
    (state, { id }) => state.passages.short[id] && state.passages.short[id].last,
    (state, { id }) => (state.students.data[id] ? state.students.data[id].gender : 'androgynous'),
    (state, { id }) => (state.passages.short[id] && state.passages.short[id].count) || 0,
    (state, { id }) => id,
    (state, { date }) => date,
    // (state, { id }) => state.students.data[id].timezone || 'Europe/Moscow',
    // GMT+3 всегда выдает устройство регистрации прохода
    () => 'Europe/Moscow',
    accessEnabled,
    (_, { t }) => t,
  ],

  (first, penult, last, gender, count, id, date, timezone, isAccessEnabled, t) => (isAccessEnabled ? ({
    items: count ? [last, penult, first].map((passage) => {
      if (!passage) return {};
      const action = passage.action === 'in'
        ? t('children:passage_in', { context: gender })
        : t('children:passage_out', { context: gender });
      const mCreated = moment(passage.created).tz(timezone);
      const theDate = (mCreated.isSame(date, 'day')
        ? mCreated.format('H:mm')
        : mCreated.format('H:mm DD.MM.YYYY'));
      return {
        text: t('children:passage_date', { action, date: theDate }),
        // убрано tz(timezone), устройство всегда возвращает время GMT+3,
        comment: passage.trackable.comment,
      };
    }) : [],

    link: count ? `/apps/${id}/access/${date}` : '',

    appString: count > 3
      ? `${t('children:count_more_passes', { count: count - 3 })} ${
        getNumEnding(count - 3, [t('children:passage'), t('children:passes_2'), t('children:passes_5')])
      }`
      : '',

    count,

  }) : { count: 0 })
);

export default makePassageInstance;
